"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.jTracker = exports.JTrackerTypes = exports.JTrackerError = void 0;
var JTrackerError = /** @class */ (function (_super) {
    __extends(JTrackerError, _super);
    function JTrackerError(message) {
        return _super.call(this, message) || this;
    }
    return JTrackerError;
}(Error));
exports.JTrackerError = JTrackerError;
var JTrackerTypes;
(function (JTrackerTypes) {
    JTrackerTypes["ERROR"] = "Error";
    JTrackerTypes["EVENT"] = "Event";
})(JTrackerTypes = exports.JTrackerTypes || (exports.JTrackerTypes = {}));
/**
 * @description jTracker is meant to be used inside of services or entities
 *              used inside of other apps via the sdk. It allows core sdk to tap into the
 *              global google analytics instance, if it exists.
 *
 * @export
 * @param {string} code the google tracking code
 * @param {string} appName the name of the app consuming the sdk
 * @param {string} entityName the name of the service or entity we are tracking
 * @param {string} [trackerName='core-sdk-tracker'] the name of the tracker used in the global space
 * @returns {JTrackerInstance}
 */
function jTracker(code, appName, entityName, trackerName) {
    if (trackerName === void 0) { trackerName = 'core-sdk-tracker'; }
    if (!appName) {
        throw new JTrackerError("appName for " + entityName + " is missing from the configuration");
    }
    if (typeof ga !== 'undefined') {
        ga('create', code, 'auto', trackerName);
        var tracker = function (type) {
            return function (action) {
                ga(trackerName + ".send", 'event', type, appName + "_" + entityName + "_" + type + "_" + action);
            };
        };
        return {
            error: tracker(JTrackerTypes.ERROR),
            event: tracker(JTrackerTypes.EVENT)
        };
    }
    else {
        return { event: function (action) { }, error: function (action) { } };
    }
}
exports.jTracker = jTracker;
//# sourceMappingURL=analytics.js.map